import { Provider } from '@angular/core';
import { CONFIG_REPOSITORY } from './config.repository.token';
import { ConfigService } from './config.service';

export function provideConfig(): Provider[] {
  return [
    {
      provide: CONFIG_REPOSITORY,
      useClass: ConfigService,
    },
  ];
}
